module.exports = __webpack_public_path__ + "static/assets/ea805e11fc5e155f702b384971b00f8c.png";